import React, { useState, useEffect, useContext } from 'react'
import { createNewRole, updateRole } from '../../../../action';
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { TabTitle } from '../../../../util/titleChanger'
import { GlobalState } from '../../../../GlobalState';
import Loading from '../../../../util/Loading';

export default function CreateRole() {
    TabTitle('Create Role')
    const { roleId } = useParams();

    const state = useContext(GlobalState);
    const [roleDetail] = state.roleAPI.roleDetail
    const [id, setId] = state.roleAPI.id;
    const [callback, setCallback] = state.roleAPI.callback;

    const [title, setTitle] = useState("Role Form");
    const [btnName, setBtnName] = useState("Save")
    const [focused, setFocused] = useState(false);
    const [values, setValues] = useState({})

    const handleFocus = (e) => {
        setFocused(true);
    }

    const onChangeValue = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const submitForm = (e) => {
        e.preventDefault();
        id > 0 ? updateRole(id, values, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
                setValues({
                    name: ""
                })
            } else {
                toast.error(res.data)
                setCallback(!callback)
            }
        }) : createNewRole(values, (res) => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
                setValues({
                    name: ""
                })
            } else {
                toast.error(res.data)
                setCallback(!callback)
            }
        })

        setValues({
            name: ""
        })
    }

    useEffect(() => {
        if (roleId > 0) {
            TabTitle("Update User")
            setTitle("Update Role Form")
            setBtnName("Update")
            setId(roleId)
            setValues(roleDetail)
        }
    }, [roleDetail, id, roleId])


    return (
        <div className="form-container">
            < header  > {title}</ header>
            <form onSubmit={submitForm} className="form">
                <div className="input-box">
                    <label htmlFor="Name">Role Name</label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder='Enter Role Name'
                        required pattern='^[A-Za-z ,]{3,}$'
                        onBlur={handleFocus}
                        value={values.name || ""}
                        focused={focused.toString()}
                        onChange={onChangeValue} />
                    <span>Role name should be above 3 characters and shouldn't any special character!</span>
                </div>
                <div className="form-button">
                    <button className="add_new" type='submit'>{btnName}</button>
                </div>
            </form>
            <ToastContainer />
        </div >
    )
}
